import { useMemo } from 'react'

export function useTableDataSourceKey<T extends { id: T['id'] }>(data: T[] | null | undefined) {
  return useMemo(() => {
    if (data == null || !Array.isArray(data)) {
      return []
    }

    return data.map((i) => ({ key: i.id, ...i }))
  }, [data])
}
